// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2lco5","label":"LabeledBox_label__1vZVo"};